!(function(global){
	function ImgTune(wrapper){

		if(typeof wrapper === 'undefined'){
			this.wrapper = 'window';
		}else{
			this.wrapper = wrapper;
		}

		this.mode = 0;
		this.slideMode = true;
		var that = this;


		if(Modernizr.touch){
			_dom(window).on('orientationchange', function(){
				that._calcSizes.call(that);
			});
		}else{
			_dom(window).on('resize', function(){
				that._calcSizes.call(that);
			});
		}
	}

	ImgTune.prototype = new Events();
	ImgTune.prototype.constructor = ImgTune;

	ImgTune.prototype._calcSizes = function(){

		if(window.innerWidth < 768 || window.innerHeight < 530){
			this.set('slideMode', false);
		}else{
			this.set('slideMode', true);
		}


		if(_.isString(this.wrapper)){
			if(window.innerWidth < 640){
				this.set('mode', 160);
			}else{
				this.set('mode', 240);
			}
			return
		}

		var rect = this.wrapper.getBoundingClientRect();

		this.wrapperWidth = rect.right - rect.left;
		this.wrapperHeight = rect.bottom - rect.top;

		if(this.wrapperWidth > 600 && this.wrapperHeight > 600){
			this.set('mode', 600);
		}else if(this.wrapperWidth > 480 && this.wrapperHeight > 480){
			this.set('mode', 480);
		}else if(this.wrapperWidth > 240 && this.wrapperHeight > 240){
			this.set('mode', 240);
		}else if(this.wrapperWidth > 160 && this.wrapperHeight > 160){
			this.set('mode', 160);
		}else{
			this.set('mode', 100);
		}
	};

	global.ImgTune = ImgTune;
})(this);